// product 
export const PRODUCT_FETCH_BEGINS = 'PRODUCT_FETCH_BEGINS';
export const PRODUCT_FETCH_SUCCESS = 'PRODUCT_FETCH_SUCCESS';
export const PRODUCT_FETCH_FAILED = 'PRODUCT_FETCH_FAILED';